import { NetworkMidLevelVizComponent } from './network-mid-level-viz.component';
import { DashboardCircleService } from './../../../shared/services/dashboard-circle-service/dashboard-circle-service';
import { RollupGroupingFooterService } from 'Src/ng2/shared/services/rollup-grouping-footer-service/rollup-grouping-footer-service';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [NetworkMidLevelVizComponent],
  imports: [CommonModule],
  exports: [NetworkMidLevelVizComponent],
  providers: [RollupGroupingFooterService, DashboardCircleService],
})
export class NetworkMidLevelVizModule {
  //
}
